import React from "react";
import {
  CONTACT_US_FROM_HEADER_PAGE_LINK,
  LOGIN_PAGE_LINK,
  PRICING_PAGE_LINK
} from "constants/links";
import Button from "segments/desktop/core-components/button/button";
import { CSSTransitionGroup } from "react-transition-group-community-version";
import LinkItemComponent from "../link-item/link-item-component";
import LinkItemWithMenuComponent from "../link-item-with-menu/link-item-with-menu-component";
import {
  FEATURES_MENU_ID,
  PRODUCTS_MENU_ID,
  RESOURCES_MENU_ID,
  SectionsHeadersMenuItemsMapping,
  SectionsLinkWithMenuMenuComponentMapping,
  USECASES_MENU_ID
} from "../../base-header-service";
import HeaderConstants from "../../constants";
import HeaderMenus from "../header-menu";
import classnames from "classnames";

const UniverseHeader = (props) => {
  const {
    showMenu,
    showButton,
    buttonConfig,
    shouldShowMainPricingLink,
    isSecondaryMenuNeeded,
    renderUnifiedLinks,
    openSignupPopup,
    showContactSales
  } = props;
  const { openedMenuId, openLinkMenu, closeLinkMenu } = props;

  const openProductsMenu = () => openLinkMenu(PRODUCTS_MENU_ID);
  const openWorkflowsMenu = () => openLinkMenu(USECASES_MENU_ID);
  const openFeaturesMenu = () => openLinkMenu(FEATURES_MENU_ID);
  const openResourcesMenu = () => openLinkMenu(RESOURCES_MENU_ID);

  const isMenuOpen = (menuId) => {
    return openedMenuId === menuId;
  };

  const renderBaseHeaderLeftLinks = () => {
    return (
      <>
        <div
          className={classnames("link-item-with-menu-component-wrapper", { "is-open": isMenuOpen(PRODUCTS_MENU_ID) })}
          role="listitem"
        >
          <LinkItemWithMenuComponent
            title="header.products"
            openMenu={openProductsMenu}
            closeMenu={closeLinkMenu}
            isOpen={isMenuOpen(PRODUCTS_MENU_ID)}
          />
        </div>
        {renderSubmenuWithTransitionIfNeeded(PRODUCTS_MENU_ID)}

        <div
          className={classnames("link-item-with-menu-component-wrapper", { "is-open": isMenuOpen(USECASES_MENU_ID) })}
          role="listitem"
        >
          <LinkItemWithMenuComponent
            title="header.useCases"
            openMenu={openWorkflowsMenu}
            closeMenu={closeLinkMenu}
            isOpen={isMenuOpen(USECASES_MENU_ID)}
          />
        </div>
        {renderSubmenuWithTransitionIfNeeded(USECASES_MENU_ID)}

        <div
          className={classnames("link-item-with-menu-component-wrapper", { "is-open": isMenuOpen(FEATURES_MENU_ID) })}
          role="listitem"
        >
          <LinkItemWithMenuComponent
            title="header.features"
            openMenu={openFeaturesMenu}
            closeMenu={closeLinkMenu}
            isOpen={isMenuOpen(FEATURES_MENU_ID)}
          />
        </div>
        {renderSubmenuWithTransitionIfNeeded(FEATURES_MENU_ID)}

        <div
          className={classnames("link-item-with-menu-component-wrapper", { "is-open": isMenuOpen(RESOURCES_MENU_ID) })}
          role="listitem"
        >
          <LinkItemWithMenuComponent
            title="header.resources"
            openMenu={openResourcesMenu}
            closeMenu={closeLinkMenu}
            isOpen={isMenuOpen(RESOURCES_MENU_ID)}
          />
        </div>
        {renderSubmenuWithTransitionIfNeeded(RESOURCES_MENU_ID)}
      </>
    );
  };

  const renderSubmenuWithTransitionIfNeeded = (menuId) => {
    //always render transition - menu rendered only if open
    const isMenuOpen = openedMenuId === menuId;

    return (
      <CSSTransitionGroup
        transitionName="submenu"
        transitionEnterTimeout={HeaderConstants.HEADER_MENU_TRANSITION_DURATION}
        transitionLeaveTimeout={HeaderConstants.HEADER_MENU_TRANSITION_DURATION}
      >
        {isMenuOpen && renderMainHeaderPopup(menuId)}
      </CSSTransitionGroup>
    );
  };

  const renderMainHeaderPopup = (menuId) => {
    const headerMenuItems = SectionsHeadersMenuItemsMapping[menuId];
    const MenuComponent = HeaderMenus[SectionsLinkWithMenuMenuComponentMapping[menuId]];

    return (
      <div className={HeaderConstants.HEADER_MENU_COMPONENT_WRAPPER_CLASS_NAME} key={menuId}>
        <nav aria-label="main submenu" className="menu-component-wrapper">
          {MenuComponent && <MenuComponent menuItems={headerMenuItems} menuId={menuId} />}
        </nav>
      </div>
    );
  };

  return (
    <nav aria-label="Main" className="base-header-desktop-content universe-header-desktop-content">
      {showMenu && (
        <div className="left-side-header-links">
          <div className="absolute-main-links" role="list">
            {renderBaseHeaderLeftLinks()}
          </div>
          {isSecondaryMenuNeeded && <div className="absolute-unified-links">{renderUnifiedLinks()}</div>}
        </div>
      )}

      <div className="right-side-header-links">
        {showMenu && shouldShowMainPricingLink() && (
          <div className="link-item-component-wrapper">
            <LinkItemComponent title="header.pricing" url={PRICING_PAGE_LINK} />
          </div>
        )}

        {(showMenu || showContactSales) && <div className="link-item-component-wrapper">
          <LinkItemComponent title="header.contactSales" url={CONTACT_US_FROM_HEADER_PAGE_LINK} />
        </div>}

        {showMenu && <div className="link-item-component-wrapper">
          <LinkItemComponent title="header.logIn" url={LOGIN_PAGE_LINK} />
        </div>}
      </div>

      {showButton && (
        <div className="header-button-wrapper">
          <Button
            {...buttonConfig}
            parentSegment={HeaderConstants.DESKTOP_HEADER_SEGMENT_NAME}
            onButtonClick={openSignupPopup}
          />
        </div>
      )}
    </nav>
  );
};

export default UniverseHeader;
